/* Date/number helpers. Даты приходят строками ДД.ММ.ГГГГ.

   «Сегодня» — настоящее. Раньше здесь стояла замороженная дата, чтобы витрина
   прототипа выглядела одинаково; из-за неё в демо ничто никогда не было
   просрочено, а сроки на экранах расходились с тем, что считает сервер. */

export const today = (): Date => new Date()

export const fmtInt = (n: number): string => new Intl.NumberFormat('ru-RU').format(n)

/* Двузначный год тоже разбирается: он приходил из прежних выгрузок и из
   файлов, заполненных до перехода на четыре знака. Отказать в нём значило бы
   потерять дату вместо того, чтобы её понять. */
export function parseRu(d: string | null | undefined): Date | null {
  if (!d || d === '—') return null
  const [dd, mm, yy] = d.split('.')
  if (!dd || !mm || !yy) return null
  const year = yy.length <= 2 ? 2000 + Number(yy) : Number(yy)
  return new Date(year, Number(mm) - 1, Number(dd))
}

/** Зеркало parseRu: Date → «ДД.ММ.ГГГГ» — как их отдаёт и принимает сервер. */
export function fmtRu(d: Date): string {
  const dd = String(d.getDate()).padStart(2, '0')
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  return `${dd}.${mm}.${d.getFullYear()}`
}

export function daysUntil(due: string | null | undefined): number | null {
  const d = parseRu(due)
  if (!d) return null
  return Math.round((d.getTime() - today().getTime()) / 86_400_000)
}

export interface Sla {
  days: number
  tone: 'overdue' | 'today' | 'soon' | 'ok'
  label: string
}

export function sla(due: string | null | undefined): Sla | null {
  const days = daysUntil(due)
  if (days == null) return null
  if (days < 0) return { days, tone: 'overdue', label: `просрочено ${-days} дн` }
  if (days === 0) return { days, tone: 'today', label: 'сегодня' }
  if (days <= 2) return { days, tone: 'soon', label: `через ${days} дн` }
  return { days, tone: 'ok', label: `через ${days} дн` }
}

/**
 * Адрес выпуска замечания: ревизия и подача — «00 v01».
 *
 * <p>Подача — номер присылки внутри ревизии, а не версия файла и не номер
 * загрузки: подрядчик кладёт в карточку сколько угодно наборов, но круг
 * начинается отправкой трансмиттала, и рецензент видел ровно присланное.
 * Счёт с нуля — так его ведёт домен (V40) и так же он стоит в самом коде
 * замечания («…-00-0-COMM-0001»).
 *
 * <p>Ведущий нуль — чтобы подпись читалась одинаково с ревизией: «00 v01», а
 * не «00 v1». Подачи не бывает у замечаний, выпущенных до V16 — тогда
 * остаётся голая ревизия, а не выдуманный ноль.
 */
export function revVer(rev: string | null | undefined, ver: number | null | undefined): string {
  const r = rev == null || rev === '' ? '—' : rev
  if (ver == null) return r
  return `${r} v${String(ver).padStart(2, '0')}`
}
